import React from 'react';

/**
 * CA —— 这只柜子已经派出去了，然后被码头关进封闭区拉了回来。
 *
 * 和 Gate Fee 那个按钮占同一个位置，但性质相反：Gate Fee 是「你去付一下就能提」，
 * 这个是「你什么也做不了，但**可能已经有司机在路上**，去告诉他别白跑」。
 * 所以它是提示不是动作 —— 点开的是任务详情，不是某个外部系统。
 *
 * 只挂在从 unassigned / assigned / picking 被拉回来的柜子上。单纯在 On Hold 里
 * 遇到封闭区的（还没排行程），列表上已经有那条红色的分段标题说明了，不需要再
 * 逐行挂一个 —— 那种情况没有人需要被通知。
 */
export const ClosedAreaButton: React.FC<{
  onClick?: () => void;
  /** Stop the click from also triggering row-level handlers (open detail, drag). */
  stopPropagation?: boolean;
}> = ({ onClick, stopPropagation }) => (
  <button
    type="button"
    onClick={(e) => {
      if (stopPropagation) e.stopPropagation();
      onClick?.();
    }}
    title="Closed Area — the terminal has locked this container; it can't be picked up. This task was already dispatched, so tell the driver."
    aria-label="Closed area — recalled from dispatch, notify the driver"
    className={
      'inline-flex items-center justify-center h-7 w-7 rounded-md border transition-colors '
      + 'border-rose-300 bg-rose-50 text-rose-700 hover:bg-rose-100 hover:border-rose-400'
    }
  >
    <span className="text-[10px] font-bold leading-none tracking-tight">CA</span>
  </button>
);

export default ClosedAreaButton;
